/**
 * RTMP-Eingang: fremde Videosignale fuer die Regie -- eine Drohne, eine
 * Action-Cam, ein per App geteilter Handy-Bildschirm.
 *
 * Gesendet wird an einen Empfangsdienst neben dem Server (MediaMTX). Der
 * nimmt RTMP an und gibt dasselbe Bild per WebRTC wieder heraus; Regie,
 * Zuschauer und Renderer holen es dort ab (WHEP). Fuer alle anderen Teile
 * der Plattform ist ein Eingang deshalb eine ganz normale Quelle -- mit
 * Hauptbild, kleinem Fenster, Ton- und Bildschalter.
 */

/** Was am Eingang gerade ankommt. `receiving`: Signal da, wird noch aufbereitet. */
export type IngestState = 'idle' | 'receiving' | 'live';

export const ingestStateLabel: Record<IngestState, string> = {
  idle: 'wartet auf Signal',
  receiving: 'Signal kommt an …',
  live: 'empfängt',
};

/** Ein Eingang, wie die Regie ihn sieht -- mit Schluessel, deshalb nie im Raum. */
export interface IngestInput {
  id: string;
  name: string;
  /** Stream-Schluessel. Wer ihn kennt, kann in dieses Event senden. */
  key: string;
  createdAt: number;
}

export interface IngestInputView extends IngestInput {
  state: IngestState;
  /** Bild, sobald ein Signal da ist. */
  video: { width: number; height: number; codec: string } | null;
  audio: boolean;
}

export interface IngestStatus {
  /** Laeuft der Empfangsdienst auf diesem Server? */
  enabled: boolean;
  /** `rtmp://host/in` -- so tragen es Larix oder OBS ein, der Schluessel getrennt. */
  server: string | null;
  inputs: IngestInputView[];
  /** Warum der Empfang nicht geht, wenn er nicht geht. */
  message: string | null;
}

/** Mehr Eingaenge gleichzeitig traegt der Server neben dem Ausgang nicht. */
export const MAX_INGEST_INPUTS = 3;
export const MAX_INGEST_NAME = 40;

/** Feste Kennungen je Eingang -- so bleibt eine Quelle nach einem Aussetzer dieselbe. */
export const ingestSourceId = (inputId: string) => `ingest-${inputId}`;
export const ingestConnectionId = (inputId: string) => `ingest:${inputId}`;

/** Komplette Adresse fuer Apps mit nur einem Feld, etwa DJI Fly. */
export const ingestUrl = (server: string, key: string) => `${server}/${key}`;
